(function ($, Drupal) {
	'use strict'

	Drupal.behaviors.headerMenu = {
		attach: function (context) {
			const header = $('.js-header', context);
			const headerLinks =  $('.js-header a', context);
			const openMenu = $('.js-open-menu', context);
			const openMegamenu = $('.js-megamenu-open', context);
			const mobileOpen = 'header--mobile-open';
			const classOpenMegamenu = 'header__megamenu--opened';
			const classIcon = 'header__open--close';
			const mobile = window.matchMedia('(max-width: 768px)');
			const pageContentBanner = $('.page-content', context);
			const industryTopHeader = $('.menu--top-header', context);
			const bannerTopNavigation = $('.paragraph--top-navigation-banner', context);

			if(bannerTopNavigation.length) {
				pageContentBanner.addClass('page-content__has-banner');
			}
			if(industryTopHeader.length < 1) {
				pageContentBanner.addClass('page-content__smaller');
				bannerTopNavigation.css('top', '140px');
				if(mobile.matches) {
					bannerTopNavigation.css('top', '96px');
				}
			} else {
				pageContentBanner.addClass('page-content__bigger');
			}

			const lastScroll = 0;
			headerLinks.each(function() {
				$(this, context).click(function(event) {
					event.stopPropagation();
				})
			});

			function bindEvents() {
				if (openMenu) {
					openMenu.click(function(e) {
						const target = e.currentTarget;
						if (target.dataset.opened === 'false') {
							header.addClass(mobileOpen);
							$(this).addClass(classIcon);
							target.dataset.opened = 'true';
							disableScroll();
						} else {
							header.removeClass(mobileOpen);
							$(this).removeClass(classIcon);
							target.dataset.opened = 'false';
							enableScroll();
						}
					});
				}
			}

			if (openMegamenu.length) {
				openMegamenu.each(function() {
					const menu = $(this).find('.js-megamenu');
					const close = $(this).find('.js-megamenu-close');

					$(this).click('click', function() {
						return menu.addClass(classOpenMegamenu);
					});

					close.click(function(e) {
						e.stopPropagation();
						menu.removeClass(classOpenMegamenu);
					});
				});
			}
			bindEvents()
		}
	}

}) (jQuery, Drupal)